import {Component, Input, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {SpeiseplanMenuService} from '../../services/speiseplanMenu.service';
import {environment} from '../../../../environments/environment';
import {StandartDialogComponent} from '../../../obs.shared/dialog/standart-dialog/standart-dialog.components';
import {MatDialog} from '@angular/material/dialog';
import {SpeiseplanDetailsComponent} from '../speiseplanDetails/speiseplanDetails.component';
import {SpeiseplanEinzelbestellerService} from '../../services/speiseplan-einzelbesteller.service';
import {DialogVerwaltungsService} from '../../../obs.shared/dialog/services/dialogVerwaltungs.service';

@Component({
  selector: 'speiseplanMenuVerpackung',
  templateUrl: './speiseplanMenuVerpackung.component.html',
  styleUrls: ['./speiseplanMenuVerpackung.component.css'],
})
export class SpeiseplanMenuVerpackungComponent implements OnInit, AfterViewInit {

  @Input('menu') menu
  @Input('config') config
  @Input('bestellungen') bestellungen
  @Input('bestellung') bestellung
  @Input('mandant') mandant
  @Input('gesperrt') gesperrt
  @Input('kunde') kunde
  @Input('tag') tag
  @Input('speiseplan') speiseplan
  @Input('speiseplanMenuDatum') speiseplanMenuDatum

  public aktiv
  public datum
  public plattform
  public verpackungsArten


  constructor(
    public speiseplanMenuService: SpeiseplanMenuService,
    private dialog: MatDialog,
    private dialogService: DialogVerwaltungsService
  ) {
  }

  ngOnInit() {
    this.plattform = environment.type
    if (this.mandant.sonderKonfiguration.Verpackungsarten){
      this.verpackungsArten = Object.values(this.mandant.sonderKonfiguration.Verpackungsarten)
    }
    if (this.kunde) {
      this.menu = this.speiseplanMenuService.speiseplanMenuBeschreibungTranslate(this.speiseplan, this.menu)
      this.bestellungen = this.speiseplan.bestellung.tage[this.speiseplanMenuDatum]
      this.bestellung = Object.values(this.bestellungen.bestellMenues).filter((element: any) => {
        if (element.menueTextId == this.menu.menueTextId) {
          return element
        }
      })[0]
      this.gesperrt = this.speiseplanMenuService.speiseplanMenuGesperrt(
        this.mandant,
        this.speiseplanMenuDatum,
        this.bestellung,
        this.config,
        this.speiseplan
      )
    } else {
      this.bestellungen = {}
      this.config = {
        bestellungen: {}
      }
      this.config.bestellungen[this.menu.menueTextId] = {markierung: false}
      this.bestellung = {
        mengeNeu: 0,
        mengeAlt: 0
      }
    }

  }

  ngAfterViewInit() {
    this.verifyMenu(this.bestellung)
  }

  public menuKarteAnzeigen(menu, verpackungsArten){
    if (this.verpackungsArten) {
      for (let verpackungsArtListe of verpackungsArten) {
        for (let verpackungsArt of verpackungsArtListe) {
          if (verpackungsArt['Einweg'] == menu.menueId){
            return false
          }
        }
      }
      return true
    }
  }

  public speiseplanGetEinweg(bestellung, verpackungsArten) {
    for (let verpackungsArt of verpackungsArten) {
      for (let index of verpackungsArt) {
        if (index.Mehrweg == bestellung.menueId) {
          return index.Einweg
        }
      }
    }
    return false
  }

  // Todo: heraus finden was damit ist MG. funktion wird halt einfach nciht benutzt. kann die raus?!
  // public verpackungsTyp(text) {
  //   if (environment.type == 'mobil') {
  //     this.dialog.open(StandartDialogComponent, {
  //       data: {
  //         title: 'Verpackungsart',
  //         text: text
  //       }
  //     })
  //   }
  // }

  open_details() {
    if (environment.type !== 'web') {
      const dialogRef = this.dialogService.optionsDialog(
        '',
        SpeiseplanDetailsComponent,
        {'Schließen': ['var(--warning)', true]},
        {menu: this.menu,
          mandant: this.mandant
        }
      )
    } else {
      this.speiseplanMenuService.seitenleistenDetailsAktualisieren(this.mandant, this.menu)
    }
  }

  verifyMenu(menu) {
    if (this.verpackungsArten) {
      for (let verpackungsArt of this.verpackungsArten) {
        for (let index of verpackungsArt) {
          if (index.Mehrweg == menu.menueId || index.Einweg == menu.menueId) {
            let correspondingMenuId = index.Mehrweg == menu.menueId ? index.Mehrweg : index.Einweg;
            let correspondingBestellung = this.bestellungen.bestellMenues[correspondingMenuId];
            let type = index.Mehrweg == menu.menueId ? 'M' : 'E'
              let menuId = type == 'M' ? this.bestellung.menueTextId : this.findeVerpackungChild(this.bestellung.menueTextId, menu.menueId)
              let element = document.getElementById(`speiseplanMenu ${menuId}`);
              if (element){
                let child = type == 'M' ? element.children[1].children[0] as HTMLElement : element.children[1].children[1] as HTMLElement
                if (child) {
                  if (correspondingBestellung.mengeNeu == correspondingBestellung.mengeAlt && this.bestellung.mengeNeu == this.bestellung.mengeAlt && this.bestellung.mengeAlt > 0) {
                    child.style.backgroundColor = '#CCE5C5';
                  } else if (correspondingBestellung.mengeNeu == correspondingBestellung.mengeAlt && this.bestellung.mengeNeu == this.bestellung.mengeAlt && this.bestellung.mengeAlt == 0){
                    child.style.backgroundColor = '#FFFFFF';
                  } else if (correspondingBestellung.mengeNeu > correspondingBestellung.mengeAlt || this.bestellung.mengeNeu > this.bestellung.mengeAlt) {
                    child.style.backgroundColor = '#ffdc88';
                  } else if (correspondingBestellung.mengeAlt > correspondingBestellung.mengeNeu && this.bestellung.mengeAlt > this.bestellung.mengeNeu) {
                    child.style.backgroundColor = '#f7bfc4';
                  } else if (this.config && this.config.bestellungen[this.menu.menueTextId].markierung) {
                    child.style.backgroundColor = '#e2e9f2';
                  }
                }
              }
            return;
          }
        }
      }
    }
  }

  findeVerpackungChild(bestellung, einweg){
    const [bestellungId, aktuellerEinweg] = bestellung.split('_');
    const foundItem = this.verpackungsArten[0].find(item => item.Einweg === einweg);
    return `${bestellungId}_${foundItem.Mehrweg}`;
  }


  onBestellungChanged(newBestellung, type) {
    for (let verpackungsArt of this.verpackungsArten) {
      for (let index of verpackungsArt) {
        if (index.Mehrweg == this.bestellung.menueId) {
          this.bestellung = this.bestellungen.bestellMenues[index.Mehrweg];
          let element = document.getElementById(`speiseplanMenu ${this.bestellung.menueTextId}`);
          let child = type == 'M' ? element.children[1].children[0] as HTMLElement : element.children[1].children[1] as HTMLElement
          if (child) {
            if (newBestellung.mengeNeu == newBestellung.mengeAlt && newBestellung.mengeAlt > 0) {
              child.style.backgroundColor = '#CCE5C5';
            } else if (newBestellung.mengeNeu == newBestellung.mengeAlt && newBestellung.mengeAlt == 0){
              child.style.backgroundColor = '#FFFFFF';
            } else if (newBestellung.mengeNeu > newBestellung.mengeAlt) {
              child.style.backgroundColor = '#ffdc88';
            } else if (newBestellung.mengeAlt > newBestellung.mengeNeu) {
              child.style.backgroundColor = '#f7bfc4';
            } else if (this.config && this.config.bestellungen[this.menu.menueTextId].markierung) {
              child.style.backgroundColor = '#e2e9f2';
            }
          }
        }
      }
    }
  }
}
